<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-calculator'"></top-line>
      <div class="back-button">
        <el-button @click="goBackWithPagination" icon="el-icon-arrow-left">返回</el-button>
      </div>
     <el-card shadow="hover" style=" margin: 20px 20px;">
      <el-descriptions title="算力规格详情" :column="2" border :colon="true" >
        <!-- 基本信息 -->
        <el-descriptions-item label="ID">{{ detail.id }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ detail.title }}</el-descriptions-item>
        <el-descriptions-item label="CPU">{{ detail.cpu }}</el-descriptions-item>
        <el-descriptions-item label="内存(GB)">{{ detail.memory_gb }}</el-descriptions-item>
        <el-descriptions-item label="GPU">{{ detail.gpu }}</el-descriptions-item>
        <el-descriptions-item label="价格">{{ detail.price }}</el-descriptions-item>
        <el-descriptions-item label="是否发布">{{ detail.is_published === 1 ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detail.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatTime(detail.updated_at) }}</el-descriptions-item>
      </el-descriptions>

      <el-row style="margin-top: 30px; text-align: center;">
        <el-button @click="goBackWithPagination">返回</el-button>
      </el-row>
    </el-card>

  </d2-container>
</template>


<script>
import topLine from "@/components/save-common/topLine.vue";
import { formatTime } from "@/libs/system/time.js";

export default {
  name: 'ComputeProductDetails',
  components: {
    topLine
  },
  data() {
    return {
      pageTitle: "算力规格详情",
      labelWidth: '120px',
      detail: {}
    }
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      this.fetchDetail(id);
    } else {
      console.error('No id provided');
    }
  },
  methods: {
    formatTime,
    async fetchDetail(id) {
      try {
        const response = await this.$axios.get(`/api-30216/api/compute-products/${id}`); 
        if (response.code === 200) {
          this.detail = response.data; // 假设响应直接包含算力规格详情
        }
      } catch (error) {
        console.error('Failed to fetch compute product details', error);
      }
    },
    goBackWithPagination() {
      const previousPagePath = '/api/compute-products'; 
      // 获取当前路由中的分页信息
      const { page, pageSize } = this.$route.query;
      this.$router.push({
        path: previousPagePath,
        query: {
          page: page || 1,       // 如果没有page参数，默认为第一页
          pageSize: pageSize || 10, // 如果没有pageSize参数，默认每页显示10条
        }
      });
    },
  }
}
</script>
<style scoped>
.back-button {
  margin-left: 20px;
}

</style>